import styled from 'styled-components';

import { fontStyles, palette } from 'theme';

export const P = styled.p`
  ${fontStyles.smallText}
  text-align: ${({ $isCentered }) => ($isCentered ? 'center' : 'left')};
  padding: ${({ $isCentered }) => ($isCentered ? '3px 0' : '3px 5px')};
  border: 2px solid ${palette.black};
  border-right-width: 0;
  box-sizing: border-box;
  min-height: 60px;
  &:last-of-type {
    border-right-width: 2px;
  }
  @media (max-width: 991px) {
    min-height: 48px;
  }
`;

export const A = styled.a.attrs(() => ({ target: '_blank', rel: 'noopener noreferrer' }))`
  ${fontStyles.smallText}
  color: ${palette.black};
  @media (hover) {
    &:hover {
      color: ${palette.darkGray};
    }
  }
`;
